import { nothing as t } from "./index-CYA3oVVY-hqmzhX60.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const n = (o) => o != null ? o : t;
export {
  n as ifDefined
};
